import { Link } from "@monta/router-js";
import styles from "./loginButton.module.scss";

const LoginButton = () => {
  return (
    <Link
      className={styles["button"]}
      href={"/auth"}
      baseURL="APPLICATION_URL"
      id="enter-or-register"
    >
      ورود و ثبت نام
    </Link>
  );
};
export default LoginButton;
